import Image from "@tiptap/extension-image";

export const MediaImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      "data-media-id": {
        default: null,
        parseHTML: (element) => element.getAttribute("data-media-id"),
        renderHTML: (attributes) =>
          attributes["data-media-id"]
            ? { "data-media-id": attributes["data-media-id"] }
            : {},
      },
    };
  },
});
